import script from "./CouponMiniShare.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouponMiniShare.vue?vue&type=script&setup=true&lang=ts"

import "./CouponMiniShare.vue?vue&type=style&index=0&id=c465273c&scoped=true&lang=css"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c465273c"]])

export default __exports__